/**
 * "What's new" sidebar entry point — OMN-368.
 *
 * Full-width row matching the Sidebar's Feedback button. Placed after Feedback,
 * so on desktop it's the bottom item and on mobile it sits just below Feedback.
 * The unread dot is the whole engagement mechanic — no modal, no nag.
 */
import React from 'react';
import { Sparkles } from 'lucide-react';
import { useWhatsNew } from './WhatsNewContext';
import { useLanguage } from '../../contexts/LanguageContext';

export const WhatsNewButton: React.FC = () => {
  const { open, hasUnread } = useWhatsNew();
  const { t } = useLanguage();

  return (
    <button
      type="button"
      onClick={open}
      className="flex items-center px-6 py-3 text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 border-t border-gray-100"
    >
      <Sparkles className="h-5 w-5 mr-3" />
      <span className="flex-1 text-left">{t('whatsNew.title')}</span>
      {hasUnread && (
        <span
          className="ml-2 h-2 w-2 rounded-full bg-red-600"
          aria-label={t('whatsNew.unreadLabel')}
        />
      )}
    </button>
  );
};
